"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRocket48 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ transform: "translate(0 .5)", fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("rect", { fill: "none", width: 48, height: 48, rx: 1 }), (0, jsx_runtime_1.jsx)("path", { d: "m27.75 12.356 7.863 7.862m-11.073-5.99c-3.797-1.636-8.665-.628-12.24 3.922l4.377 4.378m17.096.932c1.635 3.797.627 8.665-3.923 12.24l-4.378-4.377M22.05 33.1l-7.15-7.15S20.681 10.62 38.3 9.7c-.996 17.542-16.25 23.4-16.25 23.4Zm3.9-8.45a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2Zm-14.648 7.452a3.25 3.25 0 0 1 4.596 4.596C14.63 37.968 9.7 38.3 9.7 38.3s.333-4.929 1.602-6.198Z", strokeLinecap: "square", stroke: "currentColor" })] })) }))); };
exports.default = SvgRocket48;
